import { ValidationErrors, ValidatorFn, AbstractControl } from "@angular/forms";

export function minNumericCharactersValidator(
  minAmount: number,
  error: ValidationErrors
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) {
      // if control is empty return no error
      return null;
    }

    // test the value of the control against the regexp supplied
    const valid = control.value.replace(/[^0-9]/g, "").length >= minAmount;

    // if true, return no error (no error), else return error passed in the second parameter
    return valid ? null : error;
  };
}



// WEBPACK FOOTER //
// ./src/app/validators/min-numeric-characters-validator.directive.ts